/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type SbRespInteriorsPhotoGallery_interiorPhotos = {
    readonly photos: ReadonlyArray<{
        readonly path: string | null;
        readonly name: string | null;
    } | null> | null;
    readonly " $fragmentRefs": FragmentRefs<"SbSharedInteriorsBrowseMore_interiorPhotos" | "interiorsModuleHelpers_interiorPhotos">;
    readonly " $refType": "SbRespInteriorsPhotoGallery_interiorPhotos";
};
export type SbRespInteriorsPhotoGallery_interiorPhotos$data = SbRespInteriorsPhotoGallery_interiorPhotos;
export type SbRespInteriorsPhotoGallery_interiorPhotos$key = {
    readonly " $data"?: SbRespInteriorsPhotoGallery_interiorPhotos$data;
    readonly " $fragmentRefs": FragmentRefs<"SbRespInteriorsPhotoGallery_interiorPhotos">;
};



const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SbRespInteriorsPhotoGallery_interiorPhotos",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "PhotosSearchBrowsePhoto",
      "kind": "LinkedField",
      "name": "photos",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "path",
          "storageKey": null
        },
        (v0/*: any*/)
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbSharedInteriorsBrowseMore_interiorPhotos"
    },
    {
      "kind": "InlineDataFragmentSpread",
      "name": "interiorsModuleHelpers_interiorPhotos",
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "InteriorPhotosModulePhotoSearchParam",
          "kind": "LinkedField",
          "name": "photoSearchParam",
          "plural": false,
          "selections": [
            (v0/*: any*/)
          ],
          "storageKey": null
        }
      ]
    }
  ],
  "type": "SearchBrowseInteriorPhotosModule",
  "abstractKey": null
};
})();
(node as any).hash = '7b1fb2521cbd75916f0ea68922b2b161';
export default node;
